import React from 'react'

import { ProductCard as ProductCardDS } from '@src/ds/blocks/product-card'
import { shouldUseDesignSystem } from '@src/utils/should-use-design-system'
import { shouldUseSvdCard } from '@src/utils/should-use-svd-card'

import { ProductCardLegacy, type ProductCardProps } from './product-card.component-legacy'

export type { ProductCardProps }

export function ProductCard(props: ProductCardProps) {
  // Transitional crash-safe guard for the SVD rollout: under v4, `props.productCard.product` is the
  // SVD shape, which the legacy/DS cards cannot render (null displayConfig, null images, string ids).
  // SVD-aware sections render <SvdProductCard> directly and never reach here; any section that still
  // routes SVD data through the legacy ProductCard is not yet wired — render nothing rather than
  // crash. Remove once every product-card section is SVD-wired.
  if (shouldUseSvdCard()) {
    return null
  }
  if (shouldUseDesignSystem()) {
    return <ProductCardDS {...props} />
  }
  return <ProductCardLegacy {...props} />
}
